export default __webpack_public_path__ + "static/move_5000.png";